var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "tw-flex tw-absolute tw-z-50 tw-w-screen tw-h-screen tw-justify-center tw-items-center",
      staticStyle: { background: "#00000075" }
    },
    [
      _c(
        "v-card",
        { staticClass: "tw-w-4/5 tw-lg:tw-w-1/3 tw-p-6" },
        [
          _c("h3", { staticClass: "tw-text-3xl tw-text-gray-700 tw-mb-3" }, [
            _vm._v("Warning")
          ]),
          _c("p", [_vm._v(_vm._s(_vm.warning))]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "tw-w-full",
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.clearWarning()
                        }
                      }
                    },
                    [_vm._v("Close")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }